import { isLocalhost } from '../serviceWorker';

export const rootUrl = isLocalhost
  ? 'http://localhost:3000/'
  : 'https://preview.reactmilkshake.com/';
